// Public API for auth feature

// Hooks & Providers
export { AuthProvider, useAuth } from './hooks/useAuth';

// Server actions
export {
	signIn,
	signUp,
	resetPassword,
	verifyToken,
	getCurrentUser,
	updateUserMetadata,
	getAccessToken,
	checkEmailExists,
} from './actions/auth-actions';

// Types
export type { AuthUser } from './types/auth.type';

// Validation schemas
export type {
	LoginFormData,
	RegisterFormData,
	ForgotPasswordFormData,
	UpdatePasswordFormData,
} from './validation/schemas';

// NOTE: authService is not exported to prevent bundling server-only code in client components
// Import directly from './api/auth-service' in server-side code (API routes, server actions)
